import * as React from 'react';
import { useTheme } from '../../../../theming/useTheme';
import { DividedCardComponent, DIVIDED_CARD_TYPES, CardComponentDataProps } from '../dividedCard/DividedCard';

const numberOfLines = 3;
const componentConfigThemeKey = 'verticalCard';

type VerticalCardThemeProps = {
  cardBackgroundColor: string;
  cardTextColor: string;
  cardTextTypography: string;
  cardDecorationColor: string;
  borderRadius: number
  boxShadowTypeNormal: string
  boxShadowTypeActive: string
  boxShadowTypeHover: string
  borderWidthTypeNormal: number
  borderWidthTypeHover: number
  borderWidthTypeActive: number
  borderColorTypeNormal: string
  borderColorTypeHover: string
  borderColorTypeActive: string
};

const mapThemeProps = (theme: VerticalCardThemeProps): VerticalCardThemeProps => {
  return {
    cardBackgroundColor: theme.cardBackgroundColor,
    cardTextColor: theme.cardTextColor,
    cardTextTypography: theme.cardTextTypography,
    cardDecorationColor: theme.cardDecorationColor,
    borderRadius: theme.borderRadius,
    boxShadowTypeNormal: theme.boxShadowTypeNormal,
    boxShadowTypeActive: theme.boxShadowTypeActive,
    boxShadowTypeHover: theme.boxShadowTypeHover,
    borderWidthTypeNormal: theme.borderWidthTypeNormal,
    borderWidthTypeHover: theme.borderWidthTypeHover,
    borderWidthTypeActive: theme.borderWidthTypeActive,
    borderColorTypeNormal: theme.borderColorTypeNormal,
    borderColorTypeHover: theme.borderColorTypeHover,
    borderColorTypeActive: theme.borderColorTypeActive,
  };
};

export const VerticalCard = (props: CardComponentDataProps) => {
  const themeContext = useTheme(mapThemeProps, componentConfigThemeKey);
  return <DividedCardComponent {...themeContext} {...props} dividedCardType={DIVIDED_CARD_TYPES.VERTICAL} showDecorationLine numberOfLines={numberOfLines} />;
};
